import { z } from "zod";

export const companyTypeEnum = z.enum([
  "limited",
  "sole_trader",
  "partnership",
  "llc",
  "s_corp",
  "freelancer",
  "lda",
]);
export type CompanyType = z.infer<typeof companyTypeEnum>;

/** Mirrors Sidequester `companies` (id 453). */
export const companySchema = z.object({
  id: z.number().int(),
  user_id: z.number().int(),
  name: z.string().min(1),
  registration_number: z.string().optional().default(""),
  country: z.string().min(2),
  company_type: companyTypeEnum.default("limited"),
  incorporation_date: z.string().nullable().optional(),
  financial_year_end_month: z.number().int().default(3),
  financial_year_end_day: z.number().int().default(31),
  vat_registered: z.boolean().default(false),
  vat_number: z.string().optional().default(""),
  currency: z.string().default("GBP"),
  sic_code: z.string().optional().default(""),
  registered_address: z.unknown().optional(),
  status: z.string().default("active"),
  source_site_id: z.number().int().nullable().optional(),
  // Companies House deadlines, populated by the CH lookup or future refresh job.
  next_accounts_due: z.string().nullable().optional(),
  next_accounts_period_end: z.string().nullable().optional(),
  next_confirmation_statement_due: z.string().nullable().optional(),
  // Xano returns timestamps as epoch-ms numbers; some endpoints serialise as ISO strings.
  created_at: z.union([z.string(), z.number()]),
  updated_at: z.union([z.string(), z.number()]),
});
export type Company = z.infer<typeof companySchema>;

export const companyCreateInputSchema = z.object({
  name: z.string().min(1, "Required"),
  country: z.string().min(2, "Required").default("GB"),
  company_type: companyTypeEnum.default("limited"),
  registration_number: z.string().optional().default(""),
  financial_year_end_month: z.number().int().min(1).max(12).default(3),
  financial_year_end_day: z.number().int().min(1).max(31).default(31),
  vat_registered: z.boolean().default(false),
  vat_number: z.string().optional().default(""),
  currency: z.string().default("GBP"),
  sic_code: z.string().optional().default(""),
  status: z.string().default("active"),
  source_site_slug: z.string().optional(),
});
export type CompanyCreateInput = z.infer<typeof companyCreateInputSchema>;
